import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo")).token
      : ""
  },
  mutations: {
    token(state, token) {
      state.token = token;
    },
    removeToken(state, val) {
      state.token = "";
    }
  },
  actions: {
    setUserInfo({ commit }, userInfo) {
      console.log(userInfo);
      commit("token", userInfo.token);
    }
  },
  getters: {
    token: state => state.token
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js